const styles = {
  root: {
    height: "100%",
    display: "flex",
    flexFlow: "column",
  },
  headerBar: {
    width: "100%",
    paddingRight: 20,
    marginTop: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderTop: "1px solid #dadada",
  },
  contentBox: {
    height: "100%",
    display: "flex",
    flexFlow: "column",
  },
  subContentBox: {
    border: "1px solid #dadada",
    background: "#fff",
    padding: "16px 20px",
    maxWidth: 660,
    marginBottom: 12,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  subContentHead: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 20,
    lineHeight: "30px",
    color: "#000",
  },
  text1: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "24px",
    color: "rgba(51, 51, 51, 0.75)",
  },
  text2: {
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    color: "rgba(51, 51, 51, 0.75)",
    marginTop: 16,
  },
  text3: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: 16,
    lineHeight: "24px",
    color: "#333",
  },
  switchWrapper: {
    display: "flex",
    alignItems: "center",
  },
  switchLabel: {
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
    color: "rgba(51, 51, 51, 0.5)",
  },
  collapseRoot: {
    marginBottom: 12,
    background: "#FFF",
    border: "1px solid #DADADA",
    maxWidth: 660
  },
  collapseHeader: {
    display: 'flex',
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16
  },
  collapseHeaderLeft: {
    width: "-webkit-fill-available",
    cursor: "pointer",
  },
  collapseContentWrapper: {
    overflow: "auto",
    overflowX: "hidden"
  },
  numberWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#F8F8F8",
    width: 25,
    height: 26,
    marginLeft: 10,
    fontSize: 12,
    lineHeight: "18px",
    textAlign: "center",
    color: "#000000"
  },
  chipsWrapper: {
    marginTop: 12,
    marginLeft: 0
  },
  rightContent: {
    width: "100%",
    fontSize: 16,
    lineHeight: "24px",
    fontWeight: 400,
    textAlign: "right",
    color: "#333",
    "& span": {
      color: "#4F6FAE",
      fontWeight: 600,
    },
  },
  btnWrapper: {
    marginTop: 24,
  },
  btn: {
    width: 100,
    height: 40,
  },
  btnStyle: {
    width: 126,
    height: 40,
    marginTop: 20,
  },
  tableWrapper: {
    marginTop: 12,
    maxHeight: "79vh",
    overflowY: "auto",
  },
  tableHeader: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#333333",
    position: "sticky",
    background: "white",
    top: -1,
  },
  tableCell: {
    padding: "16px",
    verticalAlign: "middle",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
    color: "#333333",
    fontWeight: 400,
  },
  extraNumber: {
    fontWeight: 600,
    color: "#4F6FAE",
  },
  binIcon: {
    fill: "none",
    stroke: "#333",
    width: 24,
    height: 24,
    "&:hover": {
      stroke: "#E75F5F",
    },
  },
  fieldBox: {
    marginTop: 40,
    display: "grid",
    gridTemplateColumns: "15% 20% 65%",
  },
  fieldLabel: {
    fontWeight: 600,
    alignSelf: "center",
    margin: 0,
  },
  fieldSelectBox: {
    alignSelf: "center",
    marginTop: -44,
  },
  fieldCheckBox: {
    display: "grid",
    gridTemplateColumns: "35% 65%",
  },
  fieldCheckBoxWrapper: {
    alignSelf: "center",
    marginTop: -10,
  },
  contentContainer: {
    height: "calc(100vh - 146px)",
    overflowY: "auto",
    padding: "0px 20px",
    margin: "20px 0px",
  },
  customRoot: {
    height: "calc(100vh - 196px)",
  },
  brokerTopMargin: {
    marginTop: 12,
  },
  emptyStyle: { color: "rgba(51, 51, 51, 0.5) !important", fontWeight: "400 !important" },
  marginStyle: { marginTop: 8 },
  leftMargin: {
    marginLeft: 32,
    color: "rgba(51, 51, 51, 0.5)",
  },
  tableContainer: {
    margin: "11px 0",
  },
  table: {
    maxHeight: "62vh",
    overflowY: "scroll",
    borderBottom: "0.5px solid #dadada",
    borderTop: "0.5px solid #dadada",
  },
  leftBox: {
    minWidth: 30,
  },
  bccList: {
    marginTop: 16,
  },
  rstBtn: {
    height: 40,
    width: 80,
    marginLeft: 12,
  },
  expansion: {
    marginBottom: 12,
  },
};

export default styles;
